"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

require("./style.scss");

var _default = {
  name: 'Breadcrumb',
  props: ['menuData'],
  data: function data() {
    return {};
  },
  render: function render() {
    var h = arguments[0];
    return h("section", {
      "class": "fe-breadcrumb"
    }, [h("el-breadcrumb", {
      "attrs": {
        "separator": "/"
      }
    }, [this.formatBreadcrumb()])]);
  },
  methods: {
    formatBreadcrumb: function formatBreadcrumb() {
      var h = this.$createElement;
      var menuData = this.menuData;
      var list = [];
      menuData.forEach(function (item) {
        item = (0, _utils.getMenuItem)(item);
        list.push(h("el-breadcrumb-item", {
          "attrs": {
            "to": {
              path: item.path
            }
          }
        }, [item.title]));
      });
      return list;
    }
  }
};
exports.default = _default;